export default __webpack_public_path__ + "assets/mp3/f76f3a7d5f5091b2dff8567814ad46a8.mp3";